export enum EAxiosResponseType {
  ARRAY_BUFFER = `arraybuffer`,
  BLOB = `blob`,
  DOCUMENT = `document`,
  JSON = `json`,
  STREAM = `stream`,
  TEXT = `text`,
}

export enum EProductSliderType {
  SQUARE = `square`,
  BORDERLESS = `borderless`,
}

export enum ESwalType {
  WARNING = `warning`,
  ERROR = `error`,
  INFO = `info`,
  SUCCESS = `success`,
  QUESTION = `question`,
}

export enum EArrowDirection {
  DOWN = `down`,
  LEFT = `left`,
  RIGHT = `right`,
  UP = `up`,
}

export enum ETimeUnit {
  MINUTE = `minute`,
  SECOND = `second`,
}

export enum EBroadcastStatus {
  COMPLETED = `completed`,
  LIVE = `live`,
  UPCOMING = `upcoming`,
}

export enum ETheme {
  LIGHT = `light`,
  GRAY = `gray`,
}

export enum EProductType {
  FRISCHEKOSMETIK = 1,
  NEM,
  MERCHANDISE,
}

export enum EGeneralPaymentTypeSymbol {
  BANK_TRANSFER = `BK`,
  CASH = `KS`,
  CASH_ON_DELIVERY = `NN`,
  CREDIT_CARD = `KK`,
  DIRECT_DEBIT = `BE`,
  EC_PAYMENT = `EC`,
  ONLINE_PAYMENT = `OZ`,
  PREPAYMENT = `VZ`,
  TELEORDER = `TO`,
}
